import { customTV } from '../../utils/tailwind';
export const DEFAULT_VARIANT = 'primary';
export const iconButton = customTV({
    base: ['inline-block', 'focus:outline-none', 'cursor-pointer', 'border-none', 'p-0'],
    variants: {
        disabled: { true: ['pointer-events-none'] },
    },
});
export const VARIANT_MAPPING = {
    primary: 'interactive.primary',
    secondary: 'interactive.secondary',
    text: 'interactive.text',
    alternativeText: 'interactive.text',
    critical: 'interactive.critical',
    contrast: 'interactive.contrast',
};
